import { useTranslation } from 'react-i18next';

export const useToolTipContent = () => {
  const { t } = useTranslation();

  return {
    bitrate: t('SPEED.SPEED_TOOLTIP'),
    sipConnectivity: t('CONNECTION.CONNECTION_TOOLTIP'),
    audioCodec: t('CODECS.AUDIO_CODEC_TOOLTIP'),
    videoCodec: t('CODECS.VIDEO_CODEC_TOOLTIP'),
  };
};
